const endpoint = "/api/landing-config";

export async function getLandingConfig() {
  const res = await fetch(endpoint, { method: "GET", cache: "no-store" });
  if (!res.ok) throw new Error("Error al obtener configuración");
  return res.json();
}

export async function updateLandingConfig({ logo, logoSecundario, background, textoBienvenida, mensajeFooter, gridAncho, gridColumnas }) {
  const hasFile =
    (logo instanceof File) || (logoSecundario instanceof File) || (background instanceof File);

  if (hasFile) {
    const fd = new FormData();
    if (textoBienvenida !== undefined) fd.append("textoBienvenida", textoBienvenida ?? "");
    if (mensajeFooter !== undefined) fd.append("mensajeFooter", mensajeFooter ?? "");
    if (gridAncho !== undefined) fd.append("gridAncho", gridAncho ?? "5xl");
    if (gridColumnas !== undefined) fd.append("gridColumnas", String(gridColumnas ?? 3));

    // logo — permitir "" para eliminar
    if (logo instanceof File) fd.append("logo", logo);
    else if (typeof logo === "string") fd.append("logoUrl", logo);

    if (logoSecundario instanceof File) fd.append("logoSecundario", logoSecundario);
    else if (typeof logoSecundario === "string") fd.append("logoSecundarioUrl", logoSecundario);

    if (background instanceof File) fd.append("background", background);
    else if (typeof background === "string") fd.append("backgroundUrl", background);

    const res = await fetch(endpoint, { method: "PUT", body: fd });
    if (!res.ok) throw new Error("Error al guardar configuración");
    return res.json();
  } else {
    const res = await fetch(endpoint, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ logo, logoSecundario, background, textoBienvenida, mensajeFooter, gridAncho, gridColumnas }),
    });
    if (!res.ok) throw new Error("Error al guardar configuración");
    return res.json();
  }
}
